// src/slices/printHouse/thunk.ts
// README.md mục 7 — async thunks cho Quản lý Nhà in, copy pattern slices/ticketType/thunk.ts.

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getPrintHouses,
  createPrintHouse as createPrintHouseAPI,
  updatePrintHouse as updatePrintHouseAPI,
  deletePrintHouse as deletePrintHouseAPI,
} from 'helpers/fakebackend_helper';
import { CreatePrintHouseDto, UpdatePrintHouseDto } from 'pages/PrintHouseManagement/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('print_house_messages');

interface GetPrintHousesParams {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  isActive?: boolean;
}

const cleanParams = (params: any): any => {
  const cleaned: any = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }
  });
  return cleaned;
};

export const fetchPrintHouses = createAsyncThunk(
  'PrintHouse/fetchPrintHouses',
  async (params: GetPrintHousesParams = {}, { rejectWithValue }) => {
    try {
      const response = await getPrintHouses(cleanParams(params));
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tai_message'));
    }
  }
);

export const createPrintHouse = createAsyncThunk(
  'PrintHouse/create',
  async (data: CreatePrintHouseDto, { rejectWithValue }) => {
    try {
      const response = await createPrintHouseAPI(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_tao_message'));
    }
  }
);

export const updatePrintHouse = createAsyncThunk(
  'PrintHouse/update',
  async (data: UpdatePrintHouseDto, { rejectWithValue }) => {
    try {
      const response = await updatePrintHouseAPI(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_cap_message'));
    }
  }
);

export const deletePrintHouse = createAsyncThunk(
  'PrintHouse/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await deletePrintHouseAPI(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('co_loi_xay_ra_khi_xoa_message'));
    }
  }
);
